var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAspectRatio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22727 0.378723C2.34033 0.378723 0 2.71905 0 5.606V24.7066C0 27.5935 2.34033 29.9339 5.22727 29.9339H38.0071C40.894 29.9339 43.2344 27.5935 43.2344 24.7066V5.606C43.2344 2.71905 40.894 0.378723 38.0071 0.378723H5.22727ZM2.09091 5.606C2.09091 3.87383 3.49511 2.46963 5.22727 2.46963H38.0071C39.7393 2.46963 41.1435 3.87383 41.1435 5.606V24.7066C41.1435 26.4388 39.7393 27.843 38.0071 27.843H5.22727C3.49511 27.843 2.09091 26.4388 2.09091 24.7066V5.606Z",
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 7,
    width: 9,
    height: 3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 20,
    width: 9,
    height: 3,
    fill: "#7F7F7F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspectRatio);
export default __webpack_public_path__ + "static/media/aspect-ratio.7d821314.svg";
export { ForwardRef as ReactComponent };